import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequestBody = (mid: string, vpas: string[]) => {
  return {
    entityId: mid,
    vpa: vpas,
  }
}

const responseParser = (data: any) => {
  return data?.data?.response?.qrDetails
}

const getMerchantQrByVpa = (mid: string, vpas: string[], tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getMerchantQrByVpa),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getRequestBody(mid, vpas),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getMerchantQrByVpa }
